import React, { useState, useEffect, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import {
  showCollabModal,
  setResetPasswordModal,
  setCollabModalData,
  getCollabs,
  getAllCollabs,
  getCompanies,
  getSingleCollabDetails,
  editCollab,
  getPostes,
  getCollabContract,
  editCollabContract,
  deleteCollabContract,
  setSingleCollabProfile,
  typeOfContractOptions,
  civiliteOptions,
  cvSources,
  setSingleCollabManagedTeams,
  optionsSortie,
  getDidNotStartSync
} from "../../components/collabs/collabsSlice"
import { useDispatch, useSelector } from "react-redux"
import styles from './CollabsView.module.css'
import Langs, { Localize } from '../../app/lang/langs'
import moment from 'moment'
import { DynamicButton } from '../../components/buttons/DynamicButton'
import { completeVitalEmail, getTagClass, showErrorToast, showSuccessToast } from "../../app/utils/helpers"
import { setIsLoading } from "../common/commonSlice"
import { checkPermission } from '../../app/utils/helpers'
import { config } from '../../app/utils/config'
import {
  setEvaluationAddModal,
  setOnEvaluateTeamId,
  setOnEvaluateCollab,
  setOnEvaluateDate,
  setAllowedToEdit
} from '../../components/evaluations/evaluationsSlice'
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { PrimeIcons } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ImageButton from '../../components/buttons/ImageButton'
import { ConfirmDeleteModal } from '../../components/popups/ConfirmDeleteModal'
import {
  deleteAsset,
  downloadAsset,
  getCollabAssets,
  uploadAsset,
  setCollabAssets,
} from '../../assets/assetsSlice'
import { Dialog } from 'primereact/dialog'
import { Col, Row } from 'react-bootstrap'
import downloadIcon from './../../assets/images/downloadIcon.png'
import downloadIconFocus from './../../assets/images/downloadIconFocus.png'
import userInfo from "../../assets/images/userInfo.png";
import userInfoFocus from "../../assets/images/userInfoFocus.png";
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import { DataView } from 'primereact/dataview'
import {
  getSubcontractors
} from '../../components/clients/clientsSlice'
import { Calendar } from 'primereact/calendar'
import { InputTextarea } from 'primereact/inputtextarea'
import {
  editCollabMission,
  getCollabMissions,
  setCollabMissions,
  deleteCollabMission,
  editCollabProfile
} from '../../components/teams/teamsSlice'
import { confirmDialog } from 'primereact/confirmdialog';
import TextButton from '../../components/buttons/TextButton'
import AddContractModal from './AddContractModal'
import AddMissionModal from './AddMissionModal'
import { InputText } from 'primereact/inputtext'
import { AddressAutocomplete } from '../../components/inputs/AddressAutocomplete'
import { InputNumber } from 'primereact/inputnumber'
import { Tag } from 'primereact/tag'
import { MultiSelect } from 'primereact/multiselect'
import { SelectInput } from '../../components/inputs/Select'
import { InputSwitch } from 'primereact/inputswitch'
import ViewContractModal from './ViewContractModal'
import ViewMissionModal from './ViewMissionModal'
import { useNavigate } from 'react-router-dom'
import { MultiStateCheckbox } from 'primereact/multistatecheckbox';
import { AssetsPannel } from "../../components/inputs/AssetsPannel";
import { WeeklyFollowupTable } from './WeeklyFollowUpTable'
import { SilaeLegend } from '../../components/collabs/SilaeLegend'
import { InlineCompletionField } from '../../components/inputs/InlineCompletionField'


export default function CollabModalDetails(props) {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userRoleId = useSelector((state) => state.login.userRoleId)
  const canEditCollabs = checkPermission(config.scopes.collabs, config.permissionTypes.edit)
  const canEditClientTeams = checkPermission(config.scopes.clientsTeams, config.permissionTypes.edit)
  const collabData = useSelector(state => state.collabs.collabModal)
  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const isMobile = useSelector((state) => state.settings.isMobile)
  const companies = useSelector((state) => state.collabs.companies)
  const singleCollabDetails = useSelector((state) => state.collabs.singleCollabDetails);
  const singleCollabProfile = useSelector((state) => state.collabs.singleCollabProfile);
  const singleCollabManagedTeams = useSelector((state) => state.collabs.singleCollabManagedTeams);
  const skillsOptions = useSelector((state) => state.collabs.skillsOptions);
  const postes = useSelector((state) => state.collabs.postes);
  const teams = useSelector((state) => state.teams.allTeams);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [missionToDelete, setMissionToDelete] = useState(null);
  const [contractToDelete, setContractToDelete] = useState(null);
  const collabAssets = useSelector((state) => state.assets.collabAssets);
  const subcontractors = useSelector((state) => state.clients.subcontractors);
  const allCollabs = useSelector((state) => state.collabs.allCollabsList);
  const collabMissions = useSelector((state) => state.teams.collabMissions);
  const [onGoingMission, setOnGoingMission] = useState(null);
  const [ongoingMissions, setOngoingMissions] = useState([]);
  const [pastMissions, setPastMissions] = useState([]);
  const [upcomingMissions, setUpcomingMissions] = useState([]);
  const collabContract = useSelector((state) => state.collabs.collabContract);
  const [actualContract, setActualContract] = useState(null);
  const [ongoingContracts, setOngoingContracts] = useState([]);
  const [pastContracts, setPastContracts] = useState([]);
  const [upcomingContracts, setUpcomingContracts] = useState([]);
  const [showAddMissionModal, setShowAddMissionModal] = useState(false);
  const [showAddContractModal, setShowAddContractModal] = useState(false)
  const [assetToDelete, setAssetToDelete] = useState(null)
  const [profileData, setProfileData] = useState({})
  const [collabDetails, setCollabDetails] = useState({})
  const [selectedContract, setSelectedContract] = useState(null)
  const [selectedMission, setSelectedMission] = useState(null)
  const [lockedMissionInput, setLockedMissionInput] = useState('lock')
  const lockOptions = [
    { value: 'unlock', icon: 'pi pi-lock-open' },
    { value: 'lock', icon: 'pi pi-lock' }
  ]

  let modifications = []

  useEffect(() => {
    dispatch(getCompanies())
    dispatch(getPostes())
    dispatch(getSubcontractors())
  }, [dispatch])

  useEffect(() => {
    if (singleCollabDetails) {
      setCollabDetails(singleCollabDetails)
    }
  }, [singleCollabDetails])

  useEffect(() => {
    if (collabData && collabData.id) {
      dispatch(getSingleCollabDetails(collabData.id))
      dispatch(getCollabAssets({ id_collab: collabData.id }))
      dispatch(getCollabMissions({ id_collab: collabData.id }))
      dispatch(getCollabContract({ id_collab: collabData.id }))
    }
  }, [collabData])

  useEffect(() => {
    if (singleCollabProfile) {
      setProfileData(singleCollabProfile)
    } else {
      setProfileData({})
    }
  }, [singleCollabProfile])


  useEffect(() => {
    if (collabMissions && collabMissions.ongoingMissions && collabMissions.ongoingMissions.length > 0) {
      setOnGoingMission(collabMissions.ongoingMissions[0])
      if (collabMissions.ongoingMissions.length > 1) {
        setOngoingMissions(collabMissions.ongoingMissions.slice(1, collabMissions.ongoingMissions.length))
      }
    } else {
      setOnGoingMission(null)
      setOngoingMissions(null)
    }
    if (collabMissions && collabMissions.pastMissions && collabMissions.pastMissions.length > 0) {
      setPastMissions(collabMissions.pastMissions)
    } else {
      setPastMissions([])
    }
    if (collabMissions && collabMissions.upcomingMissions && collabMissions.upcomingMissions.length > 0) {
      setUpcomingMissions(collabMissions.upcomingMissions)
    } else {
      setUpcomingMissions([])
    }
  }, [collabMissions])

  useEffect(() => {
    if (collabContract && collabContract.ongoingContracts && collabContract.ongoingContracts.length > 0) {
      setActualContract(collabContract.ongoingContracts[0])
      if (collabContract.ongoingContracts.length > 1) {
        setOngoingContracts(collabContract.ongoingContracts.slice(1, collabContract.ongoingContracts.length))
      }
    } else {
      setActualContract(null)
      setOngoingContracts([])
    }
    if (collabContract && collabContract.pastContracts && collabContract.pastContracts.length > 0) {
      setPastContracts(collabContract.pastContracts)
    } else {
      setPastContracts([])
    }
    if (collabContract && collabContract.upcomingContracts && collabContract.upcomingContracts.length > 0) {
      setUpcomingContracts(collabContract.upcomingContracts)
    } else {
      setUpcomingContracts([])
    }
  }, [collabContract])

  const handleClose = (wipe) => {
    dispatch(showCollabModal(false))
    setCollabMissions({})
    setOnGoingMission([])
    setPastMissions([])
    setUpcomingMissions([])
    setOngoingMissions([])
    setActualContract(null)
    setPastContracts([])
    setUpcomingContracts([])
    setOngoingContracts([])
    setSingleCollabManagedTeams([])
    setLockedMissionInput('lock')
    if (wipe) {
      dispatch(setCollabModalData({ show: false }))
    }
  }
  function handleFieldNumberChange(key, value) {
    let params = { id: collabDetails.id }
    params[key] = value || 0
    setCollabDetails(current => ({
      ...current,
      ...params
    }))
  }
  const numberInputBodyTemplate = (data, key) => {
    return <InputNumber
      min={0}
      max={999}
      id={data.id}
      data-key={data[key]}
      // disableKeyboard = {true}
      disabled={!checkPermission(config.scopes.collabs, config.permissionTypes.edit)}
      onChange={(e) => handleFieldNumberChange(key, e.value)}
      value={collabDetails && collabDetails[key]} />
  }

  function handleContractFieldChange(key, value) {
    if (key == "sortie_date" && value) {
      value = moment(value).endOf("day").toDate()
    }
    let params = { id: actualContract.id }
    params[key] = value || null
    setActualContract(current => ({
      ...current,
      ...params,
      ...getDidNotStartSync(current, key, params[key])
    }))
  }

  function handleMissionFieldChange(key, value) {
    console.log(key, value)
    let params = { id: collabData.id }
    params[key] = value || null
    setOnGoingMission(current => ({
      ...current,
      ...params
    }))
  }

  function handleFieldChange(key, value) {
    let params = { id: collabDetails.id }
    params[key] = value || null
    setCollabDetails(current => ({
      ...current,
      ...params
    }))
  }

  // missions can only be added when the collab has a contract to attach them to:
  // the ongoing one, or the earliest upcoming one when the collab is hired for a
  // future date and no contract has started yet
  const missionContract = useMemo(() => {
    if (actualContract) return actualContract
    if (!upcomingContracts || upcomingContracts.length === 0) return null
    return [...upcomingContracts].sort((a, b) =>
      moment(a.entree_date).diff(moment(b.entree_date)))[0]
  }, [actualContract, upcomingContracts])

  function handleAddMissionClick() {
    if (!missionContract) {
      return showErrorToast("MISSION_REQUIRES_CONTRACT")
    }
    setShowAddMissionModal(true)
  }

  // a picked address suggestion sets street/city/postal code together
  function handleAddressSelect(fields) {
    setCollabDetails(current => ({
      ...current,
      id: current.id,
      ...fields
    }))
  }

  function handleProfileFieldChange(key, value) {
    let params = { id: profileData.id }
    params[key] = value || null
    setProfileData(current => ({
      ...current,
      ...params
    }))
  }

  const handleTeamChange = (selectedOption) => {
    if (selectedOption.value != onGoingMission.id_team) {
      handleMissionFieldChange('id_team', selectedOption.value)
    }
  }

  const handleMissionPosteChange = (selectedOption) => {
    if (selectedOption.value != onGoingMission.id_poste) {
      handleMissionFieldChange('id_poste', selectedOption.value)
    }
  }

  const handleLockChange = (value) => {
    // Only warn when unlocking (i.e. enabling team/position editing)
    if (value === 'unlock') {
      confirmDialog({
        header: Localize('MISSION_UNLOCK_WARNING_TITLE'),
        message: Localize('MISSION_UNLOCK_WARNING_MSG'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: Localize('YES'),
        rejectLabel: Localize('NO'),
        accept: () => setLockedMissionInput('unlock'),
      })
    } else {
      setLockedMissionInput(value)
    }
  }

  const handleCollabCiviliteChange = (selectedOption) => {
    if (selectedOption.value != collabDetails.title) {
      handleFieldChange('title', selectedOption.value)
    }
  }

  const removeMission = (missionId) => {
    dispatch(deleteCollabMission({
      id_membership: missionId
    })).then((response) => {
      if (response && response.payload && response.payload.responseData && response.payload.responseData.status == 1) {
        setPastMissions(pastMissions?.filter(m => m.id_mission != missionId))
        setUpcomingMissions(upcomingMissions?.filter(m => m.id_mission != missionId))
        setOngoingMissions(ongoingMissions?.filter(m => m.id_mission != missionId))
      }
    })
  }

  const removeContract = async (contractId) => {
    let response = await dispatch(deleteCollabContract({
      id_contract: contractId
    })).unwrap()

    if (response && response.responseData && response.responseData.status == 1) {
      dispatch(getCollabContract({ id_collab: collabData.id }))
    }
  }

  const confirmDeleteMission = () => {
    if (missionToDelete) {
      removeMission(missionToDelete.id_mission)
      setMissionToDelete(null);
      setShowConfirmDeleteModal(false);
    }
  }

  const confirmDeleteContract = () => {
    if (contractToDelete) {
      removeContract(contractToDelete.id)
      setContractToDelete(null)
      setShowConfirmDeleteModal(false)
    }
  }

  const handleFileUpload = async (file, type = 'collabs') => {
    if (!file || !['collabs'].includes(type))
      return
    const filename = file.name
    const tableName = type
    try {

      if (type === 'collabs') {
        dispatch(setIsLoading(true))

        await dispatch(
          uploadAsset({
            file,
            tableName,
            idParent: collabDetails.id,
            filename,
          })
        ).unwrap()
        dispatch(getCollabAssets({ id_collab: collabDetails.id }))
      }
      dispatch(setIsLoading(false))
    } catch (error) {
      console.error(`Error uploading file for ${type}:`, error)
      dispatch(setIsLoading(false))
    }
  }
  const navToTeam = (rowData) => {
    const encodedLabel = encodeURIComponent(rowData.name);
    navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
    handleClose()
    //setSelectedTeams([rowData.id_team])
  }
  const teamBodyTemplate = (rowData) => {
    return (
      <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.name}</a>
    )
  }
  function renderCollabData() {

    if (!collabDetails) {
      return <p>
        <Langs str="Aucune donnée disponible" />
      </p>
    }

    const renderFields = (fields) => {
      return fields.map((field, index) => {
        const isFullWidth = field.fullWidth
        if (field.label === 'assetPannel') {
          return (
            <Row key={index} className="p-fluid">
              <Col xs={12} className="my-3">
                {field.value}
              </Col>
            </Row>
          )
        }
        return (
          <Row key={index} className="p-fluid">
            {isFullWidth ? (
              <Col xs={12} className="my-3">
                {field.value}
              </Col>
            ) : (
              <Row>
                <Col
                  xs={6}
                  className={`fw-bold my-3 ${field.silae ? styles.silaeFieldLabel : ""}`}
                  title={field.silae ? Localize("SILAE_SYNCED_FIELD") : undefined}
                >
                  <Langs str={field.label} />
                </Col>
                <Col xs={6} className="ms-auto my-3">
                  {field.value}
                </Col>
              </Row>
            )}
          </Row>
        )
      })
    }

    const renderContractFields = () => {
      if (!actualContract) {
        return <div className='text-center'>
          <Langs str="No contract for this collab" /><br />
          <TextButton handleClick={() => setShowAddContractModal(true)}
            label="Add contract" />
        </div>
      }
      const isExterne = actualContract.type_collab === 'externe'

      if (isExterne) {
        const externeFields = [
          {
            label: 'Société',
            value: (
              <Dropdown
                value={actualContract.id_company}
                onChange={(selectedOption) => handleContractFieldChange('id_company', selectedOption ? selectedOption.value : '')}
                options={companies}
                placeholder="Sélectionnez une société"
              />
            )
          },
          {
            label: 'Sous traitants',
            value: (
              <Dropdown
                value={actualContract.id_subcontractor}
                filter
                options={subcontractors.map(sub => ({ label: sub.name, value: sub.id }))}
                onChange={(selectedOption) => handleContractFieldChange('id_subcontractor', selectedOption ? selectedOption.value : '')}
                placeholder="Sélectionnez un Fournisseur"
                width="100%"
              />
            )
          },
          {
            label: 'Localisation',
            value: (
              <InputText
                value={actualContract.localization}
                onChange={(e) => handleContractFieldChange('localization', e.target.value)}
              />
            )
          },
          {
            label: 'Type de contrat',
            value: (
              <Dropdown
                value={actualContract.type_contrat}
                options={typeOfContractOptions}
                onChange={(selectedOption) => handleContractFieldChange('type_contrat', selectedOption ? selectedOption.value : '')}
                placeholder="Sélectionnez un type de contrat"
              />
            )
          },
          {
            label: "Date de début du contrat",
            value: <Calendar
              value={actualContract.entree_date && new Date(actualContract.entree_date)}
              onChange={(e) => handleContractFieldChange('entree_date', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: "Date de fin du contrat",
            value: <Calendar
              value={actualContract.sortie_date && new Date(actualContract.sortie_date)}
              onChange={(e) => handleContractFieldChange("sortie_date", e.value)}
              showIcon
              minDate={actualContract.entree_date && new Date(actualContract.entree_date)}
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: 'motif_sortie',
            value: (
              <Dropdown
                value={actualContract.motif_sortie}
                options={optionsSortie}
                showClear
                className={actualContract.sortie_date && !actualContract.motif_sortie ? 'p-invalid' : ''}
                onChange={(e) => handleContractFieldChange('motif_sortie', e.value)}
              />
            )
          },
          {
            label: 'Responsable contractuel',
            value: (
              <Dropdown
                filter
                value={actualContract.responsable_contractuel}
                onChange={(selectedOption) => handleContractFieldChange('responsable_contractuel', selectedOption ? selectedOption.value : '')}
                options={allCollabs}
                placeholder="Sélectionnez un responsable"
              />
            )
          },
          {
            label: 'N°CP',
            value: (
              <InputText
                value={actualContract.nb_cp}
                onChange={(e) => handleContractFieldChange('nb_cp', e.target.value)}
              />
            )
          },
          {
            label: 'Date début CP',
            value: (
              <Calendar
                value={actualContract.date_debut_cp && new Date(actualContract.date_debut_cp)}
                onChange={(e) => handleContractFieldChange('date_debut_cp', e.value)}
                dateFormat="dd/mm/yy"
                showIcon
              />
            )
          },
          {
            label: 'Date fin CP',
            value: (
              <Calendar
                value={actualContract.date_fin_cp && new Date(actualContract.date_fin_cp)}
                onChange={(e) => handleContractFieldChange('date_fin_cp', e.value)}
                dateFormat="dd/mm/yy"
                minDate={actualContract.date_debut_cp && new Date(actualContract.date_debut_cp)}
                showIcon
              />
            )
          },
          {
            label: 'Date fin nouveau CP',
            value: (
              <Calendar
                value={actualContract.new_date_debut_cp && new Date(actualContract.new_date_debut_cp)}
                onChange={(e) => handleContractFieldChange('new_date_debut_cp', e.value)}
                dateFormat="dd/mm/yy"
                minDate={actualContract.date_debut_cp && new Date(actualContract.date_debut_cp)}
                showIcon
              />
            )
          },
          {
            label: 'TJM Achat',
            value: (
              <InputText
                value={actualContract.tjm_achat}
                onChange={(e) => handleContractFieldChange('tjm_achat', e.target.value)}
              />
            )
          },
          {
            label: 'TJM Vente',
            value: (
              <InputText
                value={actualContract.tjm_vente}
                onChange={(e) => handleContractFieldChange('tjm_vente', e.target.value)}
              />
            )
          },
          {
            label: 'Mutuelle',
            value: (
              <InputText
                value={actualContract.mutuelle}
                onChange={(e) => handleContractFieldChange('mutuelle', e.target.value)}
              />
            )
          },
          {
            label: 'Pass Navigo',
            value: (
              <InputText
                value={actualContract.pass_navigo}
                onChange={(e) => handleContractFieldChange('pass_navigo', e.target.value)}
              />
            )
          },
          {
            label: 'Tickets Restaurant',
            value: (
              <InputText
                value={actualContract.ticket_restaurant}
                onChange={(e) => handleContractFieldChange('ticket_restaurant', e.target.value)}
              />
            )
          },
          {
            label: 'Commentaires',
            value: (
              <InputTextarea
                value={actualContract.comments}
                onChange={(e) => handleContractFieldChange('comments', e.target.value)}
                style={{ height: '100px' }}
              />
            )
          },
          {
            label: 'Did not start',
            value: <InputSwitch checked={actualContract.did_not_start == "yes"}
              onChange={(e) => handleContractFieldChange('did_not_start', e.value ? "yes" : "no")} />
          },
          {
            label: 'created_by',
            value: <label>{actualContract.createdBy}</label>
          }
        ]
        return renderFields(externeFields)
      } else {
        // Champs pour les collaborateurs internes (lecture seule)
        const interneFields = [
          {
            label: 'Did not start',
            value: <InputSwitch checked={actualContract.did_not_start == "yes"}
              onChange={(e) => handleContractFieldChange('did_not_start', e.value ? "yes" : "no")} />
          },
          {
            label: 'Situation',
            value: <div style={{ color: (["Présent", "Actif"].includes(collabDetails.statut) ? "green" : "red") }}>
              <strong>{collabDetails.statut}</strong>
            </div>
          },
          {
            label: 'Matricule',
            silae: true,
            value: collabDetails.matricule || "-"
          },
          {
            label: 'Entité',
            silae: true,
            value: actualContract.id_company || "-"
          },
          {
            label: 'Type de contrat',
            silae: true,
            value: actualContract.type_contrat || "-"
          },
          {
            label: 'Statut emploi',
            silae: true,
            value: actualContract.statut_emploi || "-"
          },
          {
            label: 'Etablissement de rattachement',
            silae: true,
            value: actualContract.etablissement || "-"
          },
          {
            label: "Date d'ancienneté",
            silae: true,
            value: <Calendar
              value={collabDetails.anciennetee_date && new Date(collabDetails.anciennetee_date)}
              onChange={(e) => handleFieldChange('anciennetee_date', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: "Date de début du contrat",
            silae: true,
            value: <Calendar
              value={actualContract.entree_date && new Date(actualContract.entree_date)}
              onChange={(e) => handleContractFieldChange('entree_date', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: 'Date de fin du contrat',
            silae: true,
            value: <Calendar
              value={actualContract.sortie_date && new Date(actualContract.sortie_date)}
              onChange={(e) => handleContractFieldChange("sortie_date", e.value)}
              showIcon
              minDate={new Date(actualContract.entree_date)}
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: 'motif_sortie',
            value: (
              <Dropdown
                value={actualContract.motif_sortie}
                options={optionsSortie}
                showClear
                className={actualContract.sortie_date && !actualContract.motif_sortie ? 'p-invalid' : ''}
                onChange={(e) => handleContractFieldChange('motif_sortie', e.value)}
              />
            )
          },
          {
            label: 'Nature emploi',
            silae: true,
            value: actualContract.nature_emploi || "-"
          },
          {
            label: 'Position',
            silae: true,
            value: actualContract.position || "-"
          },
          {
            label: 'Coefficient',
            silae: true,
            value: actualContract.coefficient || "-"
          },
          {
            label: 'CodeCSP',
            silae: true,
            value: actualContract.code_csp || "-"
          },
          {
            label: 'Solde CPN',
            value: collabDetails.solde_cp_current || '-'
          },
          {
            label: 'Solde CPN-1',
            value: collabDetails.solde_cp_old || '-'
          },
          {
            label: "Période d'essai 1",
            silae: true,
            value: actualContract.periode_essai_1 ? moment(actualContract.periode_essai_1).format("DD-MM-YYYY") : "-"
          },
          {
            label: 'Durée période essai 1',
            silae: true,
            value: actualContract.duree_periode_essai_1 || "-"
          },
          {
            label: "Période d'essai 2",
            silae: true,
            value: actualContract.periode_essai_2 ? moment(actualContract.periode_essai_2).format("DD-MM-YYYY") : "-"
          },
          {
            label: 'Durée période essai 2',
            silae: true,
            value: actualContract.duree_periode_essai_2 || "-"
          },
          {
            label: "Date d'autorisation d'embauche",
            value: <Calendar
              value={collabDetails.date_autorisation_embauche && new Date(collabDetails.date_autorisation_embauche)}
              onChange={(e) => handleFieldChange('date_autorisation_embauche', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: "Date d'autorisation de licenciement",
            value: <Calendar
              value={collabDetails.date_autorisation_licenciement && new Date(collabDetails.date_autorisation_licenciement)}
              onChange={(e) => handleFieldChange('date_autorisation_licenciement', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
            />
          },
          {
            label: 'Dedit de formation',
            silae: true,
            value: <InputText
              maxLength={50}
              value={actualContract.dedit_formation}
              onChange={(e) => handleContractFieldChange('dedit_formation', e.target.value)}
            />
          },
          {
            label: 'id_tutor',
            value: (
              <Dropdown
                value={actualContract.id_tutor}
                options={[...allCollabs].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: "base" }))}
                showClear
                onChange={(e) => handleContractFieldChange('id_tutor', e.value)}
              />
            )
          },
          {
            label: 'school',
            value: <InputText
              maxLength={100}
              value={actualContract.school}
              onChange={(e) => handleContractFieldChange('school', e.target.value)}
            />
          },
          {
            label: 'school_contact',
            value: <InputText
              maxLength={100}
              value={actualContract.school_contact}
              onChange={(e) => handleContractFieldChange('school_contact', e.target.value)}
            />
          },
          {
            label: 'diploma',
            value: <InputText
              maxLength={100}
              value={actualContract.diploma}
              onChange={(e) => handleContractFieldChange('diploma', e.target.value)}
            />
          },
          {
            label: 'training_cost',
            value: <InputText
              maxLength={50}
              value={actualContract.training_cost}
              onChange={(e) => handleContractFieldChange('training_cost', e.target.value)}
            />
          },
          {
            label: 'remaining_cost',
            value: <InputText
              maxLength={50}
              value={actualContract.remaining_cost}
              onChange={(e) => handleContractFieldChange('remaining_cost', e.target.value)}
            />
          },
          {
            label: 'Commentaires',
            value: (
              <InputTextarea
                value={actualContract.comments}
                onChange={(e) => handleContractFieldChange('comments', e.target.value)}
                style={{ height: '100px' }}
              />
            )
          },
          {
            label: 'created_by',
            value: <label>
              {actualContract.createdBy || <Tag value="SILAE" style={{ background: "orange" }} />}
            </label>
          }
        ]
        return renderFields(interneFields)
      }
    }

    const assetListTemplate = (items) => {
      if (!items || items.length === 0) return null;

      let list = items.map((asset, index) => {
        return assetTemplate(asset, index);
      })
      return <div className="grid grid-nogutter">{list}</div>;
    }

    const assetTemplate = (asset, index) => {
      const downBtn = (asset) => {
        return (
          <ImageButton
            onClick={() => {
              dispatch(
                downloadAsset({
                  tableName: asset.table_name,
                  idParent: asset.id_parent,
                  filename: asset.filename,
                })
              )
            }}
            image={downloadIcon}
            imageFocus={downloadIconFocus}
            active={true}
            width={22}
          />
        )
      }
      const deleteBtn = (asset) => {
        if (!canEditCollabs) return null 
        return (
          <ImageButton
            onClick={() => {
              setAssetToDelete(asset);
              setShowConfirmDeleteModal(true);
            }}
            image={deleteIcon}
            imageFocus={deleteIconFocus}
            active={true}
            width={22}
          />
        )
      }

      return (
        <Row className='py-2' style={{ borderBottom: "1px #D9D9D9 solid" }}>
          <Col lg={10}>
            {asset.filename}
          </Col>
          <Col lg={1}>
            {downBtn(asset)}
          </Col>
          <Col lg={1}>
            {deleteBtn(asset)}
          </Col>
        </Row>
      )
    }

    const renderMissionFields = () => {
      if (!onGoingMission) {
        return <div className='text-center'>
          <Langs str="No mission for this collab" /><br />
          {canEditClientTeams && <TextButton handleClick={() => handleAddMissionClick()}
            label="Add mission" />}
        </div>
      }
      const fields = [
        {
          label: 'Team',
          value: onGoingMission ? (
            <Dropdown
              value={onGoingMission.id_team}
              options={teams}
              onChange={handleTeamChange}
              filter
              disabled={lockedMissionInput === 'lock' || !canEditClientTeams}
            />
          ) : (
            "-"
          )
        },
        {
          label: 'Poste',
          value: onGoingMission ? (
            <Dropdown
              value={onGoingMission.id_poste}
              options={postes}
              onChange={handleMissionPosteChange}
              filter
              disabled={lockedMissionInput === 'lock' || !canEditClientTeams}
            />
          ) : (
            "-"
          )
        },
        {
          label: 'Date de début',
          value: onGoingMission ? (
            <Calendar
              value={onGoingMission.start_date && new Date(onGoingMission.start_date)}
              onChange={(e) => handleMissionFieldChange('start_date', e.value)}
              showIcon
              dateFormat="dd/mm/yy"
              disabled={!canEditClientTeams}
            />
          ) : (
            "Pas de mission"
          )
        },
        {
          label: 'Date de fin',
          value: onGoingMission ? (
            <Calendar
              value={onGoingMission.end_date && new Date(onGoingMission.end_date)}
              onChange={(e) => handleMissionFieldChange('end_date', e.value)}
              showIcon
              minDate={onGoingMission.start_date && new Date(onGoingMission.start_date)}
              dateFormat="dd/mm/yy"
              disabled={!canEditClientTeams}
            />
          ) : (
            "Pas de mission"
          )
        },
        {
          label: 'Créé par',
          value: onGoingMission && onGoingMission.created_by_nom && onGoingMission.created_by_prenom ? (
            `${onGoingMission.created_by_nom} ${onGoingMission.created_by_prenom}`
          ) : (
            "-"
          )
        },
        {
          label: 'Mis à jour par',
          value: onGoingMission && onGoingMission.updated_by_nom && onGoingMission.updated_by_prenom ? (
            `${onGoingMission.updated_by_nom} ${onGoingMission.updated_by_prenom}`
          ) : (
            "-"
          )
        },
        {
          label: 'assetPannel',
          value: <AssetsPannel
            tableName='team_members'
            idParent={onGoingMission?.id_mission}
            assets={onGoingMission?.assets}
            uploadCallBackFunction={() => { }}
            deleteCallBackFunction={() => { }}
            label="Assets"
            parentSetter={setOnGoingMission}
            readOnly={!canEditClientTeams}
          />
        }
      ]
      if (userRoleId == 1) {
        fields.unshift({
          label: '',
          value: onGoingMission ? (
            <Col className='w-100 d-flex justify-content-end'>
              <span className='pe-3'><Langs str={lockedMissionInput} /></span>
              <MultiStateCheckbox value={lockedMissionInput}
                onChange={(e) => handleLockChange(e.value)}
                options={lockOptions}
                optionValue="value"
                empty={false} />
            </Col>
          ) : (
            "-"
          )
        })
      }
      return renderFields(fields)
    }

    const renderProfileFields = () => {
      let cvDate = profileData.cv_date
      let firstExpDate = profileData.first_experience_date
      const fields = [
        {
          label: 'Date de dernière mise à jour du CV',
          value: <Calendar
            value={cvDate ? new Date(cvDate) : null}
            onChange={(e) => handleProfileFieldChange('cv_date', e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        },
        // {
        //   label: 'Position',
        //   value: <Dropdown
        //     value={profileData.id_poste}
        //     options={postes}
        //     filter
        //     onChange={(e) => handleProfileFieldChange('id_poste', e.value)}
        //   />
        // },
        {
          label: 'Date de 1ère expérience',
          value: <Calendar
            value={firstExpDate ? new Date(firstExpDate) : null}
            onChange={(e) => handleProfileFieldChange('first_experience_date', e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        },
        {
          label: 'Compétences',
          value: <SelectInput
            values={profileData.skills}
            options={skillsOptions}
            onChange={(values) => handleProfileFieldChange('skills', values.map(v => v.value))}
            isMulti
            filter
          />
        },
        {
          label: 'Pièces jointes',
          value: (
            <div>
              <DataView
                value={collabAssets}
                listTemplate={assetListTemplate}
                paginator
                paginatorPosition="top"
                rows={5}
                className="card p-2"
                style={{ height: "240px" }}
              />
              {canEditCollabs && <input
                className=" form-control"
                type="file"
                id="formFile"
                onChange={(e) => handleFileUpload(e.target.files[0], 'collabs')}
                style={{ marginTop: '10px' }}
              />}
            </div>
          ),
          fullWidth: true
        }
      ]
      return renderFields(fields);
    }

    const renderPersonalDataFields = () => {
      const isExterne = actualContract && actualContract.type_collab === 'externe'
      // Silae only syncs internes — externe values are manually entered
      const isSilaeSynced = !isExterne
      let fields = [
        {
          label: 'Copyright',
          value: <InputSwitch checked={collabDetails.copyright == "yes"}
            onChange={(e) => handleFieldChange('copyright', e.value ? "yes" : "no")} />
        },
        {
          label: 'Email Perso Iso',
          value: <InputSwitch checked={collabDetails.accord_email_cse == "yes"}
            onChange={(e) => handleFieldChange('accord_email_cse', e.value ? "yes" : "no")} />
        },
        {
          label: 'Mail Vital',
          silae: isSilaeSynced,
          value: isExterne
            // the Vital address only needs its local part typed: the domain is
            // offered as ghost text, Tab accepts it
            ? <InlineCompletionField
              value={collabDetails.email}
              completion={completeVitalEmail(collabDetails.email)}
              onAccept={(completed) => handleFieldChange('email', completed)}>
              <InputText value={collabDetails.email}
                onChange={(e) => handleFieldChange('email', e.target.value)} />
            </InlineCompletionField>
            : (collabDetails.email || "-")
        },
        {
          label: 'Login Type',
          silae: isSilaeSynced,
          value: <Tag style={{ background: collabDetails.type_login == "O365" ? "orange" : "blue" }}
            value={collabDetails.type_login} />
        },
        {
          label: 'emergency_contact',
          value: <InputText value={collabDetails.emergency_contact}
            onChange={(e) => handleFieldChange('emergency_contact', e.target.value)} />
        },
        {
          label: 'Civilite',
          silae: isSilaeSynced,
          value: isExterne ? (
            <Dropdown
              value={collabDetails.title}
              options={civiliteOptions}
              onChange={handleCollabCiviliteChange}
              filter
            />
          ) : (collabDetails.title || "-")
        },
        {
          label: 'Nom',
          silae: isSilaeSynced,
          value: isExterne
            ? <InputText value={collabDetails.nom}
              onChange={(e) => handleFieldChange('nom', e.target.value)} />
            : (collabDetails.nom || "-")
        },
        {
          label: 'Prénom',
          silae: isSilaeSynced,
          value: isExterne
            ? <InputText value={collabDetails.prenom}
              onChange={(e) => handleFieldChange('prenom', e.target.value)} />
            : (collabDetails.prenom || "-")
        },
        {
          label: "Date de naissance",
          silae: isSilaeSynced,
          value: isExterne
            ? (
              <Calendar
                value={collabDetails.date_naissance && new Date(collabDetails.date_naissance)}
                onChange={(e) => handleFieldChange('date_naissance', e.value)}
                showIcon
                dateFormat="dd/mm/yy"
              />
            ) : (
              collabDetails.date_naissance || "-"
            )
        },
        {
          label: 'Security Number',
          silae: isSilaeSynced,
          value: collabDetails.security_number || "-"
        },
        {
          label: 'Ville de résidence',
          silae: isSilaeSynced,
          value:
            <AddressAutocomplete
              type="municipality"
              placeholder="CITY_SEARCH_PLACEHOLDER"
              value={collabDetails.city}
              onSelect={(option) => handleAddressSelect(option
                ? { city: option.city, postal_code: option.postcode }
                : { city: null })}
            />
        },
        {
          label: 'Code Postal',
          silae: isSilaeSynced,
          value: <InputText value={collabDetails.postal_code} readOnly />
        },
        {
          label: 'Rue',
          silae: isSilaeSynced,
          value: <AddressAutocomplete
            value={collabDetails.address}
            onSelect={(option) => handleAddressSelect(option
              ? { address: option.name, city: option.city, postal_code: option.postcode }
              : { address: null })}
          />
        },
        {
          label: 'Fin Titre Séjour',
          silae: isSilaeSynced,
          value: <Calendar
            value={collabDetails.date_fin_titre_sejour && new Date(collabDetails.date_fin_titre_sejour)}
            onChange={(e) => handleFieldChange('date_fin_titre_sejour', e.value)}
            dateFormat="dd/mm/yy"
          />
        },
        {
          label: 'Téléphone portable',
          silae: isSilaeSynced,
          value: isExterne
            ? <InputText value={collabDetails.mobile_number}
              onChange={(e) => handleFieldChange('mobile_number', e.target.value)} />
            : (collabDetails.mobile_number || "-")
        },
        {
          label: 'Téléphone fixe',
          silae: isSilaeSynced,
          value: isExterne
            ? <InputText value={collabDetails.telephone_number}
              onChange={(e) => handleFieldChange('telephone_number', e.target.value)} />
            : (collabDetails.telephone_number || "-")
        },
        {
          label: 'Mail Perso',
          silae: isSilaeSynced,
          value: isExterne
            ? <InputText value={collabDetails.email_perso}
              onChange={(e) => handleFieldChange('email_perso', e.target.value)} />
            : (collabDetails.email_perso || "-")
        },
        {
          label: 'Nationalité',
          silae: isSilaeSynced,
          value: <InputText value={collabDetails.nationality}
            onChange={(e) => handleFieldChange('nationality', e.target.value)} />
        },
        {
          label: 'Coopteur',
          value: <Dropdown
            value={collabDetails.coopteur}
            options={allCollabs}
            onChange={(e) => handleFieldChange('coopteur', e.target.value)}
            filter
          />
        },
        {
          label: 'Prime cooptation versée',
          value: <InputSwitch checked={collabDetails.prime_cooptation_versee == "yes"}
            onChange={(e) => handleFieldChange('prime_cooptation_versee', e.value ? "yes" : "no")} />
        },
        {
          label: "Date théorique prime de cooptation",
          value: <Calendar
            value={collabDetails.date_theorique_prime_cooptation && new Date(collabDetails.date_theorique_prime_cooptation)}
            onChange={(e) => handleFieldChange('date_theorique_prime_cooptation', e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        },
        {
          label: 'Source CV',
          value: (
            <Dropdown
              value={collabDetails.cv_source}
              onChange={(selectedOption) => handleFieldChange('cv_source', selectedOption.value)}
              options={cvSources}
              placeholder="Sélectionnez une source"
            />
          )
        },
        {
          label: 'RQTH',
          value: (
            <Dropdown
              value={collabDetails.is_handicap}
              onChange={(selectedOption) => handleFieldChange('is_handicap', selectedOption.value)}
              options={[{ label: 'Oui', value: 1 }, { label: 'Non', value: 0 }]}
              placeholder=""
            />
          )
        },
        {
          label: "Date début de attestation RQTH",
          value: <Calendar
            value={collabDetails.handicap_doc_start_date && new Date(collabDetails.handicap_doc_start_date)}
            onChange={(e) => handleFieldChange('handicap_doc_start_date', e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        },
        {
          label: "Date fin de attestation RQTH",
          value: <Calendar
            value={collabDetails.handicap_doc_end_date && new Date(collabDetails.handicap_doc_end_date)}
            onChange={(e) => handleFieldChange('handicap_doc_end_date', e.value)}
            showIcon
            dateFormat="dd/mm/yy"
          />
        },
      ]
      if (!isExterne) {
        fields = fields.concat([
          { label: "Nombre d'enfants", silae: true, value: collabDetails["nb_enfants"] },
          { label: "Date de naissance(s) enfant(s)", silae: true, value: collabDetails["dates_naissances_enfants"] },
          { label: 'Frais téléphonique', value: numberInputBodyTemplate(collabDetails, 'frais_tel') },
          { label: 'Frais téléphonique', value: numberInputBodyTemplate(collabDetails, 'frais_tel') },
          { label: 'Frais de transport', value: numberInputBodyTemplate(collabDetails, 'forfait_deplacement') },
          { label: 'Prime Objectif', value: numberInputBodyTemplate(collabDetails, 'prime_objectif') },
          { label: 'Prime Qualité', value: numberInputBodyTemplate(collabDetails, 'prime_qualite') },
          { label: 'Prime Mission', value: numberInputBodyTemplate(collabDetails, 'prime_mission') }
        ])
      }
      return renderFields(fields)
    }

    function showContractDetails(row) {
      setSelectedContract(row.data)
    }

    function showMissionDetails(row) {
      setSelectedMission(row.data)
    }

    return (
      <TabView style={{ "padding-bottom": "50px" }} className='p-tabview-ex' activeIndex={collabData.tabIndex || 0}>
        {props.tabs?.includes('mission') && (
          <TabPanel header="Mission">
            {renderMissionFields()}
            <div className='mt-4'>
              <DataTable
                value={[
                  ...(Array.isArray(pastMissions) ? pastMissions : []),
                  ...(Array.isArray(ongoingMissions) ? ongoingMissions : []),
                  ...(Array.isArray(upcomingMissions) ? upcomingMissions : [])
                ]}
                paginator
                rows={5}
                breakpoint="960px"
                selectionMode="single"
                onRowDoubleClick={showMissionDetails}
              >
                <Column
                  field="team_name"
                  header="Client"
                  body={(rowData) => (
                    <span style={{ color: pastMissions?.includes(rowData) ? "#db5856" : "#008000" }}>
                      {rowData.team_name || "-"}
                    </span>
                  )}
                />
                <Column
                  field="poste_name"
                  header="Poste"
                  body={(rowData) => (
                    <span style={{ color: pastMissions?.includes(rowData) ? "#db5856" : "#008000" }}>
                      {rowData.poste_name || "-"}
                    </span>
                  )}
                />
                <Column
                  field="start_date"
                  header="Date Début"
                  body={(rowData) =>
                    rowData.start_date ? (
                      <span style={{ color: pastMissions?.includes(rowData) ? "#db5856" : "#008000" }}>
                        {new Date(rowData.start_date).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </span>
                    ) : (
                      "-"
                    )
                  }
                />
                <Column
                  field="end_date"
                  header="Date Fin"
                  body={(rowData) =>
                    rowData.end_date ? (
                      <span style={{ color: pastMissions?.includes(rowData) ? "#db5856" : "#008000" }}>
                        {new Date(rowData.end_date).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </span>
                    ) : (
                      "-"
                    )
                  }
                />
                {canEditClientTeams && <Column
                  header={<ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => handleAddMissionClick()}
                    active={true}
                    tooltip="Add mission"
                    width={24}
                    style={{ minWidth: '6rem' }}
                  />}
                  body={(rowData) => (
                    <ImageButton
                      image={deleteIcon}
                      imageFocus={deleteIconFocus}
                      onClick={() => {
                        setMissionToDelete(rowData);
                        setShowConfirmDeleteModal(true);
                      }}
                      active={true}
                      tooltip="Delete"
                      width={32}
                    />
                  )}
                />}
              </DataTable>
              {props.page == "collabs" && singleCollabManagedTeams && singleCollabManagedTeams.length > 0 && (<div>
                <DataTable value={singleCollabManagedTeams} >
                  <Column field="name" body={teamBodyTemplate} header="Équipe"></Column>
                  <Column field="manager_role" header="Rôle"></Column>
                </DataTable>
              </div>)}
            </div>
          </TabPanel>
        )}
        {props.tabs?.includes('contrat') && (
          <TabPanel header="Contrat">
            {renderContractFields()}
            <div className='mt-4'>
              <DataTable
                value={[
                  ...(Array.isArray(pastContracts) ? pastContracts : []),
                  ...(Array.isArray(ongoingContracts) ? ongoingContracts : []),
                  ...(Array.isArray(upcomingContracts) ? upcomingContracts : [])
                ]}
                paginator
                rows={5}
                breakpoint="960px"
                selectionMode="single"
                onRowDoubleClick={showContractDetails}
              >
                <Column
                  field="type_contrat"
                  header="Type de contrat"
                  body={(rowData) => {
                    const isUpcoming = upcomingContracts?.some((contract) => contract.id === rowData.id)
                    const isPast = pastContracts?.some((contract) => contract.id === rowData.id)
                    return (
                      <span style={{ color: isUpcoming ? "#008000" : isPast ? "#db5856" : "black" }}>
                        {rowData.type_contrat || "-"}
                      </span>
                    );
                  }}
                />
                <Column
                  field="start_date"
                  header="Date Début"
                  body={(rowData) => {
                    const isUpcoming = upcomingContracts?.some((contract) => contract.id === rowData.id)
                    const isPast = pastContracts?.some((contract) => contract.id === rowData.id)
                    return rowData.entree_date ? (
                      <span style={{ color: isUpcoming ? "#008000" : isPast ? "#db5856" : "black" }}>
                        {new Date(rowData.entree_date).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </span>
                    ) : (
                      "-"
                    )
                  }}
                />
                <Column
                  field="end_date"
                  header="Date Fin"
                  body={(rowData) => {
                    const isPast = pastContracts?.some((contract) => contract.id === rowData.id);
                    return rowData.sortie_date ? (
                      <span style={{ color: isPast ? "#db5856" : "black" }}>
                        {new Date(rowData.sortie_date).toLocaleDateString("fr-FR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </span>
                    ) : (
                      "-"
                    )
                  }}
                />
                <Column header={
                  <ImageButton
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => setShowAddContractModal(true)}
                    active={true}
                    alt="Ajouter Contrat"
                    width={24}
                    style={{ minWidth: '6rem' }}
                  />
                }
                  body={(rowData) => (
                    <ImageButton
                      image={deleteIcon}
                      imageFocus={deleteIconFocus}
                      onClick={() => {
                        setContractToDelete(rowData)
                        setShowConfirmDeleteModal(true)
                      }}
                      active={true}
                      tooltip="Delete"
                      width={32}
                    />
                  )}
                />
              </DataTable>
            </div>
          </TabPanel>
        )}
        {props.tabs?.includes('suivis') && collabMissions && collabMissions.followups && collabMissions.followups.length && (
          <TabPanel header="Suivis Mission">
            <WeeklyFollowupTable data={collabMissions.followups} />
          </TabPanel>
        )}
        {props.tabs?.includes('profil') && (
          <TabPanel header="Profil">
            {renderProfileFields()}
          </TabPanel>
        )}

        {props.tabs?.includes('donneesPerso') && (
          <TabPanel header="Données Personnelles">
            {renderPersonalDataFields()}
          </TabPanel>
        )}
      </TabView>
    )
  }

  const renderModalheader = () => {
    const isExterneCollab = actualContract && actualContract.type_collab === 'externe'
    return (
      <div className={styles.headerContainer}>
        <div className={styles.avatar}>
          {collabData.nom && collabData.nom.charAt(0).toUpperCase()}
          {collabData.prenom && collabData.prenom.charAt(0).toUpperCase()}
        </div>
        <Row>
          <Row>
            <Col className="d-flex justify-items-start aligh-items-center">
              <label className='me-3'>{collabData.nom} {collabData.prenom}</label>
              <Tag severity={getTagClass(actualContract ? actualContract.type_collab : "None")}
                value={Localize(actualContract ? actualContract.type_collab : "None")} /></Col>
          </Row>
          <div className={styles.collabInfo}>
            <i className={PrimeIcons.PHONE} style={{ color: 'green', marginRight: '5px' }}></i>
            {collabData.mobileNumber || collabData.mobile_number || 'N/A'}
          </div>
          <div className={styles.collabInfo}>
            <i className={PrimeIcons.ENVELOPE} style={{ color: 'blue', marginRight: '5px' }}></i>
            {collabData.email || 'N/A'}
          </div>
        </Row>
        {/* the legend lives in the dialog header so it stays visible while the
            body scrolls — the fields it describes span every tab */}
        {!isExterneCollab && <SilaeLegend sx={{ ml: 3 }} />}
      </div>
    )
  }

  const renderModalBody = () => {
    return (
      <Modal.Body>
        {renderCollabData()}
      </Modal.Body>
    )
  }

  function renderResetPasswordBtn() {
    return
    if (checkPermission(config.scopes.collabs, config.permissionTypes.edit)) {
      if (props.page == "collabs") {
        return (
          <DynamicButton
            onClick={() => resetDialogVisible()}
            className='me-auto'
            title={<Langs str="reset_password" />}
            active={true}
            color="red"
          />
        )
      }
    }
  }
  function renderEvaluationBtn() {
    if (checkPermission(config.scopes.evaluations, config.permissionTypes.edit, collabData.id_team)) {
      if (props.page == "groups" && props.type == "Collabs") {
        return (
          <Col lg={3}>
            <DynamicButton
              onClick={() => addEvaluationDialog()}
              className='me-auto'
              title={<Langs str="EVALUATE" />}
              active={true}
              color="blue"
            />
          </Col>
        )
      }
    }
  }

  function renderSaveBtn() {

    if (!canEditCollabs) return null 

    modifications = []
    if (collabContract && collabContract.ongoingContracts && collabContract.ongoingContracts[0] && JSON.stringify(actualContract) !== JSON.stringify(collabContract.ongoingContracts[0])) {
      modifications.push("contract")
    }
    if (collabMissions && collabMissions.ongoingMissions && collabMissions.ongoingMissions[0] && JSON.stringify(onGoingMission) !== JSON.stringify(collabMissions.ongoingMissions[0])) {
      modifications.push("mission")
    }
    if (JSON.stringify(profileData) !== JSON.stringify(singleCollabProfile)) {
      modifications.push("profile")
    }
    if (collabDetails && JSON.stringify(collabDetails) !== JSON.stringify(singleCollabDetails)) {
      modifications.push("collab")
    }
    if (modifications.length) {
      return (
        <Col lg={3}>
          <DynamicButton
            onClick={() => handleSaveBtn()}
            className='me-auto'
            title={<Langs str="Save" />}
            active={true}
            color="green"
          />
        </Col>
      )
    }
  }

  function getFormattedDate(date) {
    return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null
  }

  const handleSaveBtn = async () => {

    let didSucceed = true

    // a contract end date cannot be saved without its motif de sortie
    if (props.tabs?.includes('contrat') && modifications.includes("contract")
      && actualContract && actualContract.sortie_date && !actualContract.motif_sortie) {
      return showErrorToast("MOTIF_SORTIE_REQUIRED")
    }

    // closing a contract requires all ongoing missions to be closed first
    // (mission end date set, on or before the contract end date)
    if (props.tabs?.includes('contrat') && modifications.includes("contract")
      && actualContract && actualContract.sortie_date) {
      const savedSortieDate = collabContract?.ongoingContracts?.[0]?.sortie_date
      const isClosingContract = getFormattedDate(actualContract.sortie_date) !== getFormattedDate(savedSortieDate)
      if (isClosingContract) {
        const missionsToCheck = [
          ...(onGoingMission ? [onGoingMission] : []),
          ...(Array.isArray(ongoingMissions) ? ongoingMissions : [])
        ]
        const openMission = missionsToCheck.find(mission =>
          !mission.end_date || moment(mission.end_date).isAfter(moment(actualContract.sortie_date), "day"))
        if (openMission) {
          return showErrorToast("CLOSE_MISSION_BEFORE_CONTRACT")
        }
      }
    }

    dispatch(setIsLoading(true))

    if (!collabData) return

    if (props.tabs?.includes('profil') && JSON.stringify(profileData) !== JSON.stringify(singleCollabProfile)) {
      const responseProfile = await dispatch(editCollabProfile({
        id: profileData.id,
        id_collab: collabData.id,
        skills: profileData.skills,
        cv_date: getFormattedDate(profileData.cv_date),
        id_poste: profileData.id_poste || null,
        first_experience_date: getFormattedDate(profileData.first_experience_date),
        requested_change: profileData.requested_change
      })).unwrap()

      const profileError = responseProfile && responseProfile["responseError"]
      if (profileError) {
        didSucceed = false
        showErrorToast(profileError.data.error)
      } else {
        dispatch(setSingleCollabProfile(profileData))
      }
    }

    if (props.tabs?.includes('mission') && modifications.includes("mission")) {
      const responseMission = await dispatch(editCollabMission({
        id_collab: collabData.id,
        ...onGoingMission,
        start_date: getFormattedDate(onGoingMission.start_date),
        end_date: getFormattedDate(onGoingMission.end_date)
      })).unwrap()

      if (responseMission.responseData?.error == "conflict") {
        didSucceed = false
        showErrorToast("MISSION_CONFLICT_ERROR")
      }

      const missionError = responseMission && responseMission["responseError"]
      if (missionError) {
        didSucceed = false
        showErrorToast(missionError.data.error)
      } else {
        dispatch(getCollabMissions({ id_collab: collabData.id }))
      }
    }

    if (props.tabs?.includes('contrat') && modifications.includes("contract")) {
      const responseContract = await dispatch(editCollabContract({
        collab_contract: {
          ...actualContract,
          sortie_date: getFormattedDate(actualContract.sortie_date),
          entree_date: getFormattedDate(actualContract.entree_date),
          date_debut_cp: getFormattedDate(actualContract.date_debut_cp),
          date_fin_cp: getFormattedDate(actualContract.date_fin_cp),
          new_date_debut_cp: getFormattedDate(actualContract.new_date_debut_cp)
        }
      })).unwrap()

      dispatch(setIsLoading(false))

      if (responseContract.responseData?.error == "conflict") {
        didSucceed = false
        return showErrorToast("CONTRACT_CONFLICT_ERROR")
      }
      const contractError = responseContract && responseContract["responseError"]
      if (contractError) {
        didSucceed = false
        return showErrorToast()
      }

      dispatch(getCollabContract({ id_collab: collabData.id }))
    }

    if (props.tabs?.includes('donneesPerso') && modifications.includes("collab")) {
      const responseCollab = await dispatch(editCollab({
        collab: {
          ...collabDetails,
          date_naissance: getFormattedDate(collabDetails.date_naissance),
          anciennetee_date: getFormattedDate(collabDetails.anciennetee_date),
          date_fin_titre_sejour: getFormattedDate(collabDetails.date_fin_titre_sejour),
          date_theorique_prime_cooptation: getFormattedDate(collabDetails.date_theorique_prime_cooptation),
          date_autorisation_licenciement: getFormattedDate(collabDetails.date_autorisation_licenciement),
          date_autorisation_embauche: getFormattedDate(collabDetails.date_autorisation_embauche),
          handicap_doc_start_date: getFormattedDate(collabDetails.handicap_doc_start_date),
          handicap_doc_end_date: getFormattedDate(collabDetails.handicap_doc_end_date)
        }
      })).unwrap()

      const collabError = responseCollab && responseCollab["responseError"]
      if (collabError) {
        didSucceed = false
        showErrorToast()
      }
    }

    if (props.page === "groups") {
      dispatch(getCollabs({ selectedTeamsIds, isCurrent: true }))
    } else {
      dispatch(getAllCollabs())
      dispatch(getSingleCollabDetails(collabData.id))
    }
    
    dispatch(setIsLoading(false))

    if (didSucceed) {
      showSuccessToast(Localize("success"))
    }
  }

  function resetDialogVisible() {
    handleClose()
    dispatch(setResetPasswordModal(true))
  }

  function addEvaluationDialog() {
    handleClose()
    if (collabData) {
      dispatch(setOnEvaluateTeamId(collabData.id_team))
      dispatch(setOnEvaluateCollab(collabData.id))
    }
    dispatch(setAllowedToEdit(true))
    dispatch(setOnEvaluateDate(Date.now()))
    dispatch(setEvaluationAddModal(true))
  }

  const renderModalFooter = () => {
    return (
      <Row className='d-flex justify-content-around pt-2'>
        {props.page === "collabs" && (
          <Col lg={3}>
            {collabData.typeLogin === "EMAIL" && renderResetPasswordBtn()}
          </Col>
        )}
        {renderSaveBtn()}
        {renderEvaluationBtn()}
      </Row>
    )
  }

  const ConfirmDelete = () => {
    return <ConfirmDeleteModal
      show={showConfirmDeleteModal}
      onHide={() => {
        setShowConfirmDeleteModal(false)
        setAssetToDelete(null)
        setMissionToDelete(null)
        setContractToDelete(null)
      }}
      onDelete={() => {
        if (assetToDelete) {
          dispatch(
            deleteAsset({
              tableName: assetToDelete.table_name,
              idParent: assetToDelete.id_parent,
              filename: assetToDelete.filename,
            })
          )
          dispatch(setCollabAssets(collabAssets.filter((asset) => asset.filename !== assetToDelete.filename)))
          setAssetToDelete(null)
        } else if (missionToDelete) {
          confirmDeleteMission()
        } else if (contractToDelete) {
          confirmDeleteContract()
        }
        setShowConfirmDeleteModal(false)
      }}
      title="Confirmation"
      message={
        assetToDelete ? (
          <p>
            <Langs str="Are you sure you want to delete the file" /> <strong>{assetToDelete.filename}</strong> ?
          </p>
        ) : missionToDelete ? (
          <p>
            <Langs str="Are you sure you want to delete this mission?" />
          </p>
        ) :
          <p>
            <Langs str="Are you sure you want to delete this contract?" />
          </p>
      }
    />
  }

  return (
    <Dialog
      visible={collabData.show}
      style={{
        width: isMobile == 2 ? '100%' : '55rem',
        height: "100vh",
        maxHeight: "100%",
        marginRight: 0
      }}
      position="right"
      onHide={() => { handleClose({ wipe: true }) }}
      footer={renderModalFooter()}
      header={renderModalheader()}
      draggable={false}
    >
      {renderModalBody()}
      <ConfirmDelete />
      <AddMissionModal show={showAddMissionModal}
        onHide={() => setShowAddMissionModal(false)}
        collabDetails={collabDetails}
        onGoingMission={onGoingMission}
        collabMissions={collabMissions}
        actualContract={missionContract} />
      <AddContractModal show={showAddContractModal}
        actualContract={actualContract}
        onHide={() => setShowAddContractModal(false)}
        collabDetails={collabDetails}
        collabContract={collabContract} />
      <ViewContractModal selectedContract={selectedContract}
        onHide={() => setSelectedContract(null)} />
      <ViewMissionModal selectedMission={selectedMission}
        onHide={() => setSelectedMission(null)} />
    </Dialog>
  )
}